import { Badge, Flex } from '@chakra-ui/react';

import { fadeInScaleAnimation } from '@texas/resources/animations/animations';
import { useTranslation } from 'react-i18next';
import { SearchPaGeneric } from '../../returnTypes';
import { SearchFilter } from '@texas/api/endpoints/search/searchApi';
import { SearchBase } from '@texas/api/endpoints/search/searchPaTypes';
import { ProductApprovalState } from '@texas/api/endpoints/productApprovalsApi';

export function PaPrinterFilter<T extends SearchBase>({
  search,
}: {
  search: SearchPaGeneric<T>;
}) {
  const { data, searchParamsRef } = search;
  const { t } = useTranslation();

  return (
    <Flex flexWrap="wrap" gap={1}>
      <PrintFilters filters={data?.branchFilters} />
      <PrintFilters filters={data?.conceptFilters} />
      <PrintFilters filters={data?.customerFilters} />
      <PrintFilters filters={data?.supplierFilters} />
      <PrintFilters filters={data?.categoryCodeFilters} />
      <PrintFilters filters={data?.productGroupFilters} />
      <PrintFilters
        filters={searchParamsRef.current.paStates?.map<SearchFilter>((x) => ({
          name: ProductApprovalState[x],
          id: x,
        }))}
      />
      <PrintFilters
        filters={
          searchParamsRef.current.showMyBrands
            ? [{ name: t('filter.myBrands'), id: 0 }]
            : undefined
        }
      />
      <PrintFilters
        filters={
          searchParamsRef.current.includeArchived
            ? [{ name: t('filter.archivedIncluded'), id: 0 }]
            : undefined
        }
      />
      <PrintFilters
        filters={
          searchParamsRef.current.searchTerm
            ? [{ name: searchParamsRef.current.searchTerm, id: 0 }]
            : undefined
        }
      />
    </Flex>
  );
}

function PrintFilters({ filters }: { filters?: SearchFilter[] }) {
  if (!filters) return null;
  return (
    <>
      {filters.map((f) => (
        <Badge animation={fadeInScaleAnimation()} key={f.id}>
          {f.name}
        </Badge>
      ))}
    </>
  );
}
